const Avatars: Record<string, string> = {
  "Georgia Institute of Technology":
    "https://storage.googleapis.com/hexlabs-public-cdn/gtbeelogo.png",
};

export default Avatars;
